import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { imageBaseURL } from '../../Api';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

function DetailHistory() {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};
  const [selectedImage, setSelectedImage] = useState(null);
  if (!item) {
    return <p>No data available</p>;
  }
  const handleRequestService = () => {
    navigate('/request-service', { state: { item } });
  };
  // const handleSeeMore = () => {
  //   navigate('/detail-images', { state: { images: item.img_path.split(',') } });
  // };
  const imagePaths = item.img_path ? item.img_path.split(',') : [];
  const beforePaths = item.sebelum_img_path
    ? item.sebelum_img_path.split(',')
    : [];
  const afterPaths = item.sesudah_img_path
    ? item.sesudah_img_path.split(',')
    : [];

  const handleOpenImage = (src) => {
    setSelectedImage(src);
  };

  const handleCloseImage = () => {
    setSelectedImage(null);
  };

  const handleDownloadAllImages = async () => {
    const zip = new JSZip();
    const folder = zip.folder("bukti-pengerjaan");
    const allPaths = [...beforePaths, ...afterPaths, ...imagePaths];
  
    for (let i = 0; i < allPaths.length; i++) {
      const path = allPaths[i];
      const originalURL = `${imageBaseURL}${path}`;
      const proxyURL = `https://master.jasaindonesiaperdana.com/api/download-image?url=${encodeURIComponent(originalURL)}`;
      const fileExt = originalURL.substring(originalURL.lastIndexOf('.'));
      const fileName = `image_${i + 1}${fileExt}`;
  
      try {
        const response = await fetch(proxyURL);
        const blob = await response.blob();
        folder.file(fileName, blob);
      } catch (err) {
        console.error(`Gagal unduh: ${originalURL}`, err);
      }
    }
  
    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, 'semua-gambar.zip');
    });
  };
  return (
    <div className="detail-page">
      <div className="subheading_wrap">
        <div>
          <h3 className="subheading_title">{item.ac.nama_ac}</h3>
        </div>
      </div>
      <div className="detail-content">
        <div className="item-detail">
          <div className="item-detail-left">Tanggal Pelayanan</div>
          <div className="item-detail-right">{item.tgl_service}</div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Merek AC</div>
          <div className="item-detail-right">{item.ac.merek_ac}</div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Serial Number</div>
          <div className="item-detail-right">
            {item.ac.serial_number != null ? item.ac.serial_number : '-'}
          </div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Ketinggian AC</div>
          <div className="item-detail-right">{item.ac.ketinggian_ac}</div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Data Terakhir Freon</div>
          <div className="item-detail-right">{item.ac.freon}</div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Keluhan/Permintaan Service</div>
          <div className="item-detail-right">{item.keluhan}</div>
        </div>
        <div className="item-detail">
          <h3 className="subheading_title">Bukti Pengerjaan</h3>
        </div>
        {(beforePaths.length > 0 || afterPaths.length > 0) && (
          <>
            <div className="item-detail">
              <div className="item-detail-left">Sebelum</div>
              <div className="item-detail-left">Sesudah</div>
            </div>
            <div className="item-detail">
              <div className="sebelum bukti_wrap">
                {beforePaths.map((path, index) => (
                  <div key={index} className="bukti_detail">
                    <img
                      src={`${imageBaseURL}${path}`}
                      alt={`Bukti Pengerjaan ${index + 1}`}
                      onClick={() => handleOpenImage(`${imageBaseURL}${path}`)}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                ))}
              </div>
              <div className="sesudah bukti_wrap">
                {afterPaths.map((path, index) => (
                  <div key={index} className="bukti_detail">
                    <img
                      src={`${imageBaseURL}${path}`}
                      alt={`Bukti Pengerjaan ${index + 1}`}
                      onClick={() => handleOpenImage(`${imageBaseURL}${path}`)}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
        {imagePaths.length > 0 && (
          <>
            <div
              className="item-detail-left"
              style={{ width: '100%', textAlign: 'center', marginTop: '20px' }}
            >
              Gambar
            </div>
            <div className="item-detail">
              {imagePaths.map((path, index) => (
                <div key={index} className="bukti_detail">
                  <img
                    src={`${imageBaseURL}${path}`}
                    alt={`Bukti Pengerjaan ${index + 1}`}
                    onClick={() => handleOpenImage(`${imageBaseURL}${path}`)}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              ))}
            </div>
          </>
        )}
        <div className="btn-request">
          <button
            className="download-images-btn"
            onClick={handleDownloadAllImages}
            style={{ marginBottom: '10px',width:'100%' }}
          >
            Download Semua Gambar
          </button>
        </div>
        <div className="btn-request">
          <button
            className="request-service-btn"
            onClick={handleRequestService} // Call the function on click
            style={{ marginTop: '10px',width:'100%' }}
          >
            Request Service
          </button>
        </div>
      </div>
      {selectedImage && (
        <div className="onlarge-image" onClick={handleCloseImage}>
          <img
            src={selectedImage}
            alt="Preview"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              boxShadow: '0 0 10px rgba(255,255,255,0.6)',
              borderRadius: '10px',
            }}
          />
          <button className="close-image" onClick={handleCloseImage}>
            &times;
          </button>
        </div>
      )}
    </div>
  );
}

export default DetailHistory;
